export function cdnApiPath(relativePath) {
  const path = relativePath.startsWith('/') ? relativePath : `/${relativePath}`;
  return `/api/v3${path}`;
}
